import styled from "styled-components";
import { Button as BaseButton } from "./Button";
import * as React from "react";
import { useCallback, useState } from "react";

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const ButtonContainer = styled.div<{ show: boolean }>`
  opacity: ${({ show }) => (show ? 1 : 0)};
  visibility: ${({ show }) => (show ? "visible" : "hidden")};
  transition: all 0.5s ease;
`;

const LinkContainer = styled(ButtonContainer)`
  position: absolute;
  top: 0;
  width: 100%;
`;

const Button = styled(BaseButton)`
  width: 181px;
  height: 61px;
  margin: auto;
  text-decoration: none;
`;

export const ContactUs = () => {
  const [showEmail, setShowEmail] = useState(false);
  const show = useCallback(() => {
    setShowEmail(true);
  }, [setShowEmail]);

  return (
    <Container>
      <ButtonContainer show={!showEmail}>
        <Button onClick={show}>Contactez-nous</Button>
      </ButtonContainer>
      <LinkContainer show={showEmail}>
        <Button as="a" href="mailto:contact@le-c.fr">
          contact@le-c.fr
        </Button>
      </LinkContainer>
    </Container>
  );
};
